import { z } from 'zod';

export const PlayerInfoSchema = z.object({
    type: z.literal('player-info'),
});
export type PlayerInfo = z.infer<typeof PlayerInfoSchema>;
